import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseBadge } from './BaseBadge';

type ComingSoonBadgeProps = {
  className?: string;
};

export const ComingSoonBadge: FC<ComingSoonBadgeProps> = ({ className }) => {
  const { t } = useTranslation();

  return <BaseBadge className={className}>{t('COMMON:comingSoon')}</BaseBadge>;
};
